









import Vue from 'vue'
import './KisweStudioLogo.scss'
import { Feature } from '@/featureFlags/featureFlags'

export default Vue.extend({
  name: 'KisweStudioLogo',
  props: {
    link: {
      type: String,
      required: false,
      default: ''
    },
    inlineStyle: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    isSelfServe (): boolean {
      return this.$hasFeature(Feature.SELF_SERVE)
    }
  }
})
